import { createFileRoute, Link } from '@tanstack/react-router'
import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle } from '@lead-magnifier/ui'
import { Plus, Building2 } from 'lucide-react'

export const Route = createFileRoute('/_admin/tenants/')({
  component: TenantsPage,
})

function TenantsPage() {
  // TODO: Fetch tenants from API
  const tenants: unknown[] = []

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold">Mandanten</h1>
          <p className="text-muted-foreground mt-1">
            Verwalte alle Messeplätze und deren Einstellungen
          </p>
        </div>
        <Link to="/tenants/new">
          <Button>
            <Plus className="h-4 w-4 mr-2" />
            Neuer Mandant
          </Button>
        </Link>
      </div>

      {tenants.length === 0 ? (
        <Card>
          <CardContent className="flex flex-col items-center justify-center py-12">
            <Building2 className="h-12 w-12 text-muted-foreground mb-4" />
            <CardTitle className="mb-2">Keine Mandanten</CardTitle>
            <CardDescription className="text-center max-w-sm mb-4">
              Erstelle den ersten Mandanten (Messeplatz), um die Plattform zu nutzen.
            </CardDescription>
            <Link to="/tenants/new">
              <Button>
                <Plus className="h-4 w-4 mr-2" />
                Ersten Mandanten anlegen
              </Button>
            </Link>
          </CardContent>
        </Card>
      ) : (
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {/* Tenant cards would go here */}
        </div>
      )}
    </div>
  )
}
